module.exports = __webpack_public_path__ + "img/music-purple.e8bcb321.svg";